import api from './api';

const PerguntaService = {
    buscar: () => {
        return api.get('/pergunta');
    },
	buscarTipoResposta: () => {
        return api.get('/pergunta/tipo-resposta');
    },
    store: (dados) => {
        let uri = "/pergunta";
        return api['post'].call(api, uri, dados);
    },
	update: (id, dados) => {
        let uri = `/pergunta/${id}`;
        return api['put'].call(api, uri, dados);
    },
    delete: (id) =>{
        let uri = '/pergunta/' + id;
        return api['delete'].call(api, uri);
    }    
};

export default PerguntaService;
